import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';

export const FilmCard = ({ film }) => {
  // Special routes for our films
  let filmPath = `/films/${film.id}`;
  if (film.id === 'older-gods') filmPath = '/films/older-gods';
  if (film.id === 'patriarch') filmPath = '/films/patriarch';
  
  const isComingSoon = film.status === 'in_production' || film.year > 2025;
  
  return (
    <Link to={filmPath} data-testid={`film-card-${film.id}`}>
      <motion.div
        whileHover={{ scale: 1.05, zIndex: 10 }}
        transition={{ duration: 0.3 }}
        className="aspect-[2/3] bg-neutral-900 relative overflow-hidden group rounded-sm cursor-pointer"
      >
        <img
          src={film.poster_url}
          alt={film.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center">
            <Play size={24} fill="white" className="text-white ml-1" />
          </div>
        </div>
        
        {/* Info */}
        <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <h3 className="font-display text-lg tracking-wide text-white uppercase">{film.title}</h3>
          <p className="text-neutral-400 text-sm mt-1">{film.year} &bull; {film.genre}</p>
        </div>

        {/* Featured Badge */}
        {film.featured && !isComingSoon && (
          <div className="absolute top-3 right-3">
            <span className="bg-orange-600 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider">
              FEATURED
            </span>
          </div>
        )}

        {/* Coming Soon Badge */}
        {isComingSoon && (
          <div className="absolute top-3 right-3">
            <span className="bg-white text-black text-xs font-bold px-2 py-1 uppercase tracking-wider">
              COMING SOON
            </span>
          </div>
        )}
      </motion.div>
    </Link>
  );
};
